import { render, staticRenderFns } from "./DMIDsideNav.vue?vue&type=template&id=f9cf0234&scoped=true&"
import script from "./DMIDsideNav.vue?vue&type=script&lang=js&"
export * from "./DMIDsideNav.vue?vue&type=script&lang=js&"
import style0 from "./DMIDsideNav.vue?vue&type=style&index=0&id=f9cf0234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cf0234",
  null
  
)

export default component.exports